const sections = document.getElementsByClassName('m-faq-rubriek-mobile');

class FAQ_Mobile {
  constructor(container) {
    this.container = container;
    this.build();
    this.addEventListeners();
  }

  build() {
    const { container } = this;

    this.questions = container.getElementsByClassName('m-faq-rubriek-mobile__question');
  }

  addEventListeners() {

    const { questions } = this;
    
    [].map.call(questions, question => question.addEventListener('click', this.handleQuestionClick.bind(this)));
  }

  handleQuestionClick(event) {
    event.preventDefault();
    const { currentTarget } = event;
    const { container } = this;

    if(currentTarget.parentElement.classList.contains('open')) {
        currentTarget.parentElement.classList.remove('open');
    } else {
        
        // Only 1 question open at a time : 

        var activeQuestionItem = container.querySelector('.open');
        if (activeQuestionItem) activeQuestionItem.classList.remove('open');

        currentTarget.parentElement.classList.add('open');
    }

  }
}

function initTabContent() {
  [].map.call(sections, section => new FAQ_Mobile(section));
}

if (sections) initTabContent();
